<template>
	<div>
   
    <v-layout row>
      <v-flex xs6>
    <v-btn @click.stop="update_list()">Refresh</v-btn>
    </v-flex>
  </v-layout>
 
  <v-layout row>
    <v-flex xs12>
      <timeline v-bind:items="items" v-bind:groups="groups" :start="chart_start" :end="chart_end" style="width: 100%; height: 400px;"></timeline>
    </v-flex>
  </v-layout>


   <v-layout row style="margin-top: 30px;">
      <v-flex xs12>
        <content-data v-if="is_settings" :list="list_id" editpath="/devices/plan/list/" :disable-import="true" ref="content"></content-data>
      </v-flex>
    </v-layout>

    <v-btn class="deep-orange" fab dark small fixed top right style="top: 90px; right: 26px;" @click.stop="open_add"><v-icon>add</v-icon></v-btn>


  </div>
</template>

<script>
import Vue from 'vue';

import ContentData from '../content/Data'
import SettingsModel from '@/models/settings.js';
import datelib from '@/lib/date.js'

import timeline from './Timeline'

export default {
	components: {
		ContentData,
    timeline
	},
  data () {
    var timestamp = Math.floor(Date.now() / 1000);

    return {
      chart_start: datelib.format(timestamp * 1000, "%Y-%m-%d"),
      chart_end: datelib.format((timestamp + 31536000)* 1000, "%Y-%m-%d"),
      rows: [],
      all_items: [],
      groups: [],
      items: [],
    }
  },
  watch: {
    "is_settings": function(newValue, oldValue) {
      if (newValue == true) {
        this.update_list();
      }
    }
  },
  mounted () {
    if (this.is_settings == true) {
      this.update_list();
    }
  },
  methods:{
    open_add() {
      this.$router.push("/devices/plan/list/" + this.list_id + "/data/new");
    },
    update_list() {
     if(!this.list_id) return;
      var url = "content_list/" + this.list_id;
      Vue.http.get(url).then((response) => {
        var resp_data = response.body;
        this.all_items = response.body;
        this.groups = _.map(resp_data, function(data) {
          return {
            id: data.id,
            content: data.name
          }
        });
        this.items = _.map(resp_data, function(data) {
          return {
            id: data.id,
            start: datelib.format(data.start_time * 1000, "%Y-%m-%d"),
            end: datelib.format(data.end_time * 1000, "%Y-%m-%d"),
            content: data.name + " " + datelib.format(data.start_time * 1000, "%d.%m") + " - " + datelib.format(data.end_time * 1000, "%d.%m"),
            group: data.id,
            editable: false,
            style: ""
          }
        })

      }, (response) => {
      });
    },
  },
  computed: {
    is_settings() {
      if (this.settings.length > 0) return true;
      return false;
    },
    settings () {
      return SettingsModel.list("device_type");
    },
    list_id() {
      return this.settings[0].value.series_list_id;
    }
  }
}
</script>

